import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=0664337d&scoped=true&"
import script from "./MainPage.vue?vue&type=script&lang=ts&"
export * from "./MainPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664337d",
  null
  
)

export default component.exports